import { formatPrice, toSentenceCase } from '../../utils/formatters.js';
import { escapeHTML } from '../../utils/escape.js';

/**
 * Componente para un producto estándar de la carta.
 *
 * La carta es puramente informativa/read-only (ordering-pedidos-section):
 * este card NUNCA renderiza el afordance de "Agregar" (`data-action="cart-add"`),
 * independientemente de `ORDERING_ENABLED`. Ese affordance vive únicamente en
 * `PedidosProductCard`/`ProductSheet` (sección `/pedidos`).
 */
export const ProductCard = (product) => `
    <div class="py-2 border-b border-border-subtle flex flex-col w-full group">
        <div class="flex justify-between items-start gap-3 w-full">
            <h3 class="text-text-primary font-bold text-[11px] leading-tight uppercase flex-1 min-w-0">
                ${escapeHTML(product.name)}
            </h3>
            <span class="text-[11px] font-black text-brand whitespace-nowrap">
                ${formatPrice(product.price)}
            </span>
        </div>
        ${product.description ? `
            <p class="text-text-muted text-[10px] mt-0.5 leading-tight">
                ${escapeHTML(toSentenceCase(product.description))}
            </p>
        ` : ''}
    </div>
`;

/**
 * Componente para una fila de variedad (ej. Pizzas Media/Entera).
 */
export const ProductVarietyRow = ({ name, description, priceMedia, priceEntera }) => `
    <div class="flex items-center py-3 border-b border-border-subtle gap-2">
        <div class="flex-1 pr-2">
            <h3 class="text-text-primary font-bold text-[11px] uppercase leading-tight">${escapeHTML(name)}</h3>
            ${description ? `<p class="text-text-muted text-[10px] mt-0.5 leading-tight">${escapeHTML(toSentenceCase(description))}</p>` : ''}
        </div>
        <div class="w-16 text-center text-[10px] font-black text-text-muted">
            ${priceMedia !== '-' ? formatPrice(priceMedia).replace('$', '') : '-'}
        </div>
        <div class="w-16 text-center text-[11px] font-black text-brand">
            ${priceEntera !== '-' ? formatPrice(priceEntera).replace('$', '') : '-'}
        </div>
    </div>
`;
